export const AdminGetters = {
  EmailLogs: 'AdminGetters.EmailLogs',
  EmailLogsCount: 'AdminGetters.EmailLogsCount',
  EmailsPerPage: 'AdminGetters.EmailsPerPage',
  CurrentEmailLogOffset: 'AdminGetters.CurrentEmailLogOffset'
};

export const AdminActions = {
  RetrieveEmailLogs: 'AdminActions.RetrieveEmailLogs',
  RetrieveEmailLogsCount: 'AdminActions.RetrieveEmailLogsCount',
  SetEmailPaginationParameters: 'AdminActions.SetEmailPaginationParameters',
  SetPaginationParams: 'AdminActions.SetPaginationParams'
};

export const AdminMutations = {
  UpdateEmailLogsCount: 'AdminMutations.UpdateEmailLogsCount',
  SetEmailPaginationParameters: 'AdminMutations.SetEmailPaginationParameters',
  UpdateEmailLogs: 'AdminMutations.UpdateEmailLogs',
  SetPaginationParams: 'AdminMutations.SetPaginationParams'
};
